import * as React from "react";

function SvgAutoMode(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={27} cy={27} r={26.5} stroke="#fff" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m 15.851785,14.997687 h -0.7693 l -3.0769,11.5385 h 1.5385 l 0.3846,-1.5385 h 3.0769 l 0.3846,1.5385 h 1.5385 z m -1.5385,8.4615 1.1538,-5 1.1539,5 z m 5.3846,-8.4615 h 1.5385 v 9.2308 l 0.7692,0.7692 h 2.3077 l 0.7692,-0.7692 v -9.2308 h 1.5385 v 10 l -1.5385,1.5385 h -3.8461 l -1.5385,-1.5385 z m 20.7692,0 h -1.923 -1.9231 l -0.7692,0.7692 -0.7693,0.7693 v 8.4615 l 1.5385,1.5385 h 3.8461 l 1.5385,-1.5385 v -8.4615 l -0.7692,-0.7693 z m -3.8461,2.3077 0.7692,-0.7692 h 2.3077 l 0.7692,0.7692 v 6.9231 l -0.7692,0.7692 h -2.3077 l -0.7692,-0.7692 z m -13.4616,10.7692 h 1.9231 l 0.7693,0.7693 0.7692,0.7692 v 8.4615 l -1.5385,1.5385 h -3.8461 l -1.5385,-1.5385 v -8.4615 l 0.7692,-0.7692 0.7693,-0.7693 z m -1.1538,1.5385 -0.7692,0.7692 v 6.9231 l 0.7692,0.7692 h 2.3077 l 0.7692,-0.7692 v -6.9231 l -0.7692,-0.7692 z m 7.3077,-13.0769 h 0.7692 v 0.7692 8.4615 0.7693 h 0.7693 0.7692 v -0.7693 -8.4615 -0.7692 h 0.7692 1.1539 0.7692 v -0.7693 -0.7692 h -0.7692 -5.3847 -0.7692 v 0.7692 0.7693 h 0.7692 z m -17.3077,11.5384 h 1.5385 l 1.923,2.3077 1.9231,-2.3077 h 1.5385 v 11.5385 h -1.5385 v -9.2308 l -1.9231,2.3077 -1.923,-2.3077 v 9.2308 h -1.5385 z m 15.3846,0 v 11.5385 h 5.3846 l 1.5385,-1.5385 v -8.4615 l -1.5385,-1.5385 z m 1.5385,1.5385 h 3.0769 l 0.7692,0.7692 v 6.9231 l -0.7692,0.7692 h -3.0769 z m 6.1538,-1.5385 v 11.5385 h 6.9231 v -1.5385 h -5.3846 v -3.8461 h 5.3846 v -1.5385 h -5.3846 v -3.0769 h 5.3846 v -1.5385 z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgAutoMode;
